import dynamic from 'next/dynamic'

export const ObservedModal = dynamic(() => import('./modal'))
